import { Address, JarvisTvConnectType, JarvisTvProduct } from '@vfde-sails/availability';
import { CmsMoreInfo } from '../../interface';
import { CableContract } from '@vfde-sails/login';
import { AddressValidationProps } from '../../container/AddressValidation';

const PRESALES = [
    JarvisTvConnectType.StandardPresale,
    JarvisTvConnectType.StartPresale,
];

const getMoreInfoHeadline = (cmsProps: CmsMoreInfo, hasKip?: boolean, tvConnectBv?: JarvisTvProduct) =>
    hasKip && tvConnectBv
        ? cmsProps.headline.kipDiscount
        : cmsProps.headline.regular;

const getMoreInfoSubline = (
    props: AddressValidationProps,
    cmsProps: CmsMoreInfo,
) => {
    if (props.customer?.hasKipContract && props.tvConnectBv) {
        return cmsProps.subline.kipDiscount;
    }

    if (props.tvConnect && PRESALES.includes(props.tvConnect.tvConnectType)) {
        return cmsProps.subline.preSales;
    }

    return cmsProps.subline.regular;
};

const getCustomerName = (contract?: CableContract) => {
    if (!contract) {
        return undefined;
    }

    return `${contract.firstName} ${contract.lastName}`;
};

const getCustomerCity = (contract?: CableContract) => {
    if (!contract) {
        return undefined;
    }

    return `${contract.address.zipcode} ${contract.address.city}`;
};

const getCustomerStreet = (address?: Address) => {
    if (!address) {
        return undefined;
    }

    const { street, housenumber, housenumberextra } = address;

    return `${street} ${housenumber}${housenumberextra ?? ''}`;
};

export default {
    getMoreInfoSubline,
    getCustomerName,
    getCustomerStreet,
    getCustomerCity,
    getMoreInfoHeadline,
};
